let BASE_URL;
if (window.location.hostname === "localhost") {
  BASE_URL = "http://localhost:8000/";
} else {
  BASE_URL = "https://admin.shipshack.net/";
}

export { BASE_URL };



// let BASE_URL;
// if (window.location.hostname === 'localhost') {
//   // GEÇİCİ: localden prod'a git
//   BASE_URL = 'https://shipshack.net/';
// } else {
//   BASE_URL = 'https://shipshack.net/';
// }

// export { BASE_URL };
